/* Project Moss — Range grid tag filtering */
(function () {
  'use strict';

  function init(container) {
    var chips = container.querySelectorAll('.moss-chip[data-filter]');
    var grid  = container.querySelector('.moss-pgrid');
    if (!chips.length || !grid) return;

    var cards = Array.from(grid.querySelectorAll('.moss-pcard'));

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-on'); });
        chip.classList.add('is-on');

        var filter = chip.dataset.filter.toLowerCase();

        cards.forEach(function (card) {
          if (filter === 'all') {
            card.classList.remove('is-hidden');
            return;
          }
          var tags = (card.dataset.tags || '').toLowerCase();
          if (tags.includes(filter)) {
            card.classList.remove('is-hidden');
          } else {
            card.classList.add('is-hidden');
          }
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[id^="moss-range-grid-"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
